import script from "./Pagenavigator.vue?vue&type=script&setup=true&lang=ts"
export * from "./Pagenavigator.vue?vue&type=script&setup=true&lang=ts"

import "./Pagenavigator.vue?vue&type=style&index=0&id=7163495c&scoped=true&lang=scss"

import exportComponent from "/builds/ext/ERCO/productdata-archive-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7163495c"]])

export default __exports__